<template>
  <div>
    <base-header class="mt-4 pb-6" type=""></base-header>
    <b-container fluid class="mt--6">
      <div>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>Customer Credit Limit Exceeded</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt--4" >
                <b-col cols="12" class="mt-3">
                    <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                            <b-th>{{language_terms['CUSTOMER']}}</b-th>
                            <b-th>{{language_terms['CREDIT_LIMIT']}} </b-th>
                            <b-th>{{language_terms['OUTSTANDING_AMT']}} </b-th>
                            <b-th>{{language_terms['EXCESS_AMT']}} </b-th>
                        </b-thead>
                        <b-tbody>
                            <tr v-for="(invoice, i) in tableItems" :key="i">
                                <td>{{invoice.name}}</td>
                                <td>{{(invoice.customer_credit_limit * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                <td>{{(invoice.os_amount_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                <td>{{(invoice.excess_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                            </tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
            </card>
            <!-- Search Results -->
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>

<script>
import moment from 'moment'
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

  export default {
    components:{
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PaginatedTables
    },
    computed:{
        ...mapState({
          language_terms: state => state.languages.language_terms,
          selected_lang: state => state.languages.selected_langauge,
        }),
    },
    async mounted()
    {
      this.loadingCounter++
      this.retrieve()
      this.loadingCounter--
    },

    data(){
      return{
        loadingCounter:0,
        selectedInvoice:[],
        reportOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:['id','customer_id','invoice_date','customer_code','Exch Rate'],filterable:false},
        report:{headers:[], rows:[]},
        rowDetailsModal:false,
        tableItems:[],
      }
    },
  
    methods:{
      async retrieve()
      {
          let payload = null
          await axios
          .post(apiRoutes["SALES_CREDIT_LIMIT_EXCEEDED_RETRIEVE"], payload, authHeader())
          .then((response) => 
          {
              if (response.data.code == 1) {
                  this.tableItems= response.data.data
              } 
              else 
              {
                  alert('Failed');
              }

          })
          .catch((error) => {
              if (error.response) {
                  Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
              }
          });
      },
    }
  }
  </script>
  